/* Iron+Steel v3 Favorites page: builds the saved grid from window.ISWishlist, add to bag, add all, clear. */

(() => {
  if (customElements.get('is-wishlist')) return;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));

  const HEART = '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.5 4.2 13a4.6 4.6 0 0 1 6.5-6.5l1.3 1.3 1.3-1.3A4.6 4.6 0 1 1 19.8 13Z"/></svg>';

  class ISWishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.empty = this.querySelector('[data-empty]');
      this.actions = this.querySelector('[data-actions]');
      this.countEl = this.querySelector('[data-count]');
      this.note = this.querySelector('[data-note]');
      this.addAllBtn = this.querySelector('[data-add-all]');
      this.cache = new Map();

      this.addAllBtn.addEventListener('click', () => this.addAll());
      this.querySelector('[data-clear]').addEventListener('click', () => {
        const store = window.ISWishlist;
        store.read().forEach((h) => store.setVariant && store.setVariant(h, null));
        store.write([]);
      });
      this.onChange = () => this.render();
      document.addEventListener('is:wishlist:change', this.onChange);

      if (window.ISWishlist) this.render();
      else window.addEventListener('DOMContentLoaded', () => this.render(), {once: true});
    }

    disconnectedCallback() {
      document.removeEventListener('is:wishlist:change', this.onChange);
    }

    money(cents) {
      const format = this.dataset.moneyFormat || '${{amount}}';
      const n = cents / 100;
      const fmt = (d, sep = ',', dec = '.') => {
        const [i, f] = n.toFixed(d).split('.');
        return i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (f ? dec + f : '');
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        if (key === 'amount_no_decimals') return fmt(0);
        if (key === 'amount_with_comma_separator') return fmt(2, '.', ',');
        if (key === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
        return fmt(2);
      });
    }

    async product(handle) {
      if (!this.cache.has(handle)) {
        const url = `${this.dataset.rootUrl.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}.js`;
        this.cache.set(handle, fetch(url).then((r) => (r.ok ? r.json() : null)).catch(() => null));
      }
      return this.cache.get(handle);
    }

    async render() {
      const store = window.ISWishlist;
      const handles = store.read().slice().reverse(); // newest first
      const variants = store.variants ? store.variants() : {};
      const products = await Promise.all(handles.map((h) => this.product(h)));

      // Drop products that no longer exist.
      const missing = handles.filter((h, i) => !products[i]);
      if (missing.length) {
        store.write(store.read().filter((h) => !missing.includes(h)));
        return;
      }

      this.items = handles.map((handle, i) => {
        const p = products[i];
        const saved = p.variants.find((v) => String(v.id) === String(variants[handle]));
        const single = p.variants.length === 1;
        const variant = saved || (single ? p.variants[0] : null);
        let state = 'choose';
        if (!p.available) state = 'sold';
        else if (variant && variant.available) state = 'add';
        return {handle, p, variant, state, savedSoldOut: saved && !saved.available && p.available};
      });

      const n = this.items.length;
      this.countEl.textContent = n === 0 ? 'No saved items' : `${n} saved ${n === 1 ? 'item' : 'items'}`;
      this.empty.hidden = n > 0;
      this.actions.hidden = n === 0;
      this.grid.hidden = n === 0;
      this.grid.innerHTML = this.items.map((it) => this.card(it)).join('');
      this.grid.removeAttribute('aria-busy');
      this.note.textContent = '';
      const addable = this.items.filter((it) => it.state === 'add').length;
      this.addAllBtn.disabled = addable === 0;
      this.bind();
    }

    card({handle, p, variant, state, savedSoldOut}) {
      const img = variant && variant.featured_image ? variant.featured_image.src : p.featured_image;
      const src = img ? `${img}${img.includes('?') ? '&' : '?'}width=` : '';
      const price = variant ? this.money(variant.price) : (p.price_varies ? `From ${this.money(p.price_min)}` : this.money(p.price));
      const compare = variant ? variant.compare_at_price : p.compare_at_price;
      const onSale = compare && compare > (variant ? variant.price : p.price);
      const detail = variant && !(p.variants.length === 1) ? ` · ${esc(variant.title.replace(/ \/ /g, ' · '))}` : '';
      let button;
      if (state === 'add') {
        button = `<button type="button" class="is-wish__add" data-add="${variant.id}">Add to bag</button>`;
      } else if (state === 'choose') {
        button = `<button type="button" class="is-wish__add is-wish__add--outline" data-quick-view="${esc(p.url)}" aria-haspopup="dialog">${savedSoldOut ? 'Size sold out, choose another' : 'Choose size'}</button>`;
      } else {
        button = `<button type="button" class="is-wish__add" disabled>Sold out</button>
          <a class="is-wish__notify" href="${esc(p.url)}?out_of_stock=true">Notify me when available</a>`;
      }
      return `
        <div class="is-gcard is-wish__card" data-handle="${esc(handle)}">
          <a href="${esc(p.url)}${variant && p.variants.length > 1 ? `?variant=${variant.id}` : ''}" class="is-gcard__link">
            <div class="is-gcard__media">
              ${src ? `<img class="is-gcard__img" src="${esc(src)}600" srcset="${esc(src)}300 300w, ${esc(src)}600 600w, ${esc(src)}900 900w" sizes="(min-width: 860px) 25vw, 50vw" alt="${esc(p.title)}" loading="lazy">` : ''}
              ${state === 'sold' ? '<span class="is-gcard__badge is-gcard__badge--sold-out">Sold out</span>' : ''}
            </div>
            <div class="is-gcard__body">
              <div class="is-gcard__title">${esc(p.title)}</div>
              <div class="is-gcard__price">${onSale ? `<span class="is-gcard__sale">${price}</span> <s>${this.money(compare)}</s>` : price}${detail}</div>
            </div>
          </a>
          <button type="button" class="is-gcard__fav" aria-pressed="true" aria-label="Remove ${esc(p.title)} from favorites" data-remove>${HEART}</button>
          ${button}
        </div>`;
    }

    bind() {
      this.grid.querySelectorAll('.is-wish__card').forEach((card) => {
        const handle = card.dataset.handle;
        card.querySelector('[data-remove]').addEventListener('click', () => {
          const store = window.ISWishlist;
          if (store.setVariant) store.setVariant(handle, null);
          store.write(store.read().filter((h) => h !== handle));
        });
        const add = card.querySelector('[data-add]');
        if (add) add.addEventListener('click', () => this.add([Number(add.dataset.add)], [add]));
        const qv = card.querySelector('[data-quick-view]');
        if (qv) qv.addEventListener('click', () => window.ISQuickView && window.ISQuickView.open(qv.dataset.quickView, qv));
      });
    }

    async add(ids, buttons) {
      buttons.forEach((b) => b.setAttribute('aria-busy', 'true'));
      try {
        const res = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: ids.map((id) => ({id, quantity: 1}))}),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Could not add to your bag');
        }
        buttons.forEach((b) => {
          b.textContent = 'Added to bag';
          b.dataset.state = 'added';
        });
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        return true;
      } catch (e) {
        this.note.textContent = e.message;
        return false;
      } finally {
        buttons.forEach((b) => b.removeAttribute('aria-busy'));
      }
    }

    async addAll() {
      const ready = this.items.filter((it) => it.state === 'add');
      const buttons = ready.map((it) => this.grid.querySelector(`[data-add="${it.variant.id}"]`)).filter(Boolean);
      const ok = await this.add(ready.map((it) => it.variant.id), [...buttons, this.addAllBtn]);
      if (!ok) return;
      this.addAllBtn.textContent = 'Added all in stock';
      const needSize = this.items.filter((it) => it.state === 'choose').length;
      this.note.textContent = needSize
        ? `${needSize} ${needSize === 1 ? 'item needs' : 'items need'} a size first. Use Choose size on ${needSize === 1 ? 'it' : 'each one'}.`
        : '';
    }
  }

  customElements.define('is-wishlist', ISWishlistPage);
})();
